import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import { ShareProvider } from './ShareContext';
import { LandingPage } from './components/LandingPage';
import { BrowseRedirect } from './components/BrowseRedirect';
import { ShopRoute } from './components/ShopRoute';
import { SubcategoryPage } from './components/SubcategoryPage';
import { SearchResultsPage } from './components/SearchResultsPage';
import { AboutPage } from './components/AboutPage';
import { AddStorePage } from './components/AddStorePage';
import { ApplyProTrialPage } from './components/ApplyProTrialPage';
import { PremiumPage } from './components/PremiumPage';
import { AppShell } from './components/AppShell';
import { PreLanderPage } from './components/PreLanderPage';
import { DealsOfTheDayPage } from './components/DealsOfTheDayPage';

function App() {
  return (
    <BrowserRouter>
      <ShareProvider>
        <Routes>
          <Route element={<AppShell />}>
            <Route path="/" element={<LandingPage />} />
            <Route path="/start" element={<PreLanderPage />} />
            <Route path="/search" element={<SearchResultsPage />} />
            <Route
              path="/sale"
              element={<Navigate to="/search?sale=1" replace />}
            />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/deal-of-the-day" element={<DealsOfTheDayPage />} />
            <Route path="/add-store" element={<AddStorePage />} />
            <Route path="/add-store/apply" element={<ApplyProTrialPage />} />
            <Route path="/premium" element={<PremiumPage />} />
            <Route path="/browse/:slug" element={<BrowseRedirect />} />
            <Route path="/shop/:slug" element={<ShopRoute />} />
            <Route
              path="/shop/:categorySlug/:subcategorySlug"
              element={<SubcategoryPage />}
            />
          </Route>
        </Routes>
      </ShareProvider>
    </BrowserRouter>
  );
}

export default App;
